import { S as Swiper } from './swiper-core-ClzX336E.js';
import { N as Navigation } from './navigation-B3kNCC8A.js';
import './create-element-if-not-defined-CpMCDYSa.js';

class PredictiveSearchSuggestions extends HTMLElement {
  connectedCallback() {
    this.setupEventListeners();
    this.setOptions();
    this.initSwiper();
  }

  setOptions() {
    this.overflow = this.dataset.overflow;

    if (this.overflow === 'true') {
      this.options = {
        slidesPerView: 1.5,
        breakpoints: {
          768: {
            slidesPerView: 2.5,
          },
        },
      };
    } else {
      this.options = {
        slidesPerView: 1,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 4,
          },
        },
      };
    }
  }

  initSwiper() {
    const swiperElements = this.querySelectorAll(
      '.swiper--product-suggestions, .swiper--collection-suggestions'
    );

    if (!swiperElements.length) {
      return;
    }

    this.swipers = Array.from(swiperElements, (element) => this.createSwiper(element));
    this.swiper = this.swipers[0];
  }

  createSwiper(element) {
    return new Swiper(element, this.getSwiperConfig());
  }

  getSwiperConfig() {
    return {
      modules: [Navigation],
      spaceBetween: 16,
      loop: true,
      ...this.options,
    };
  }

  setupEventListeners() {
    const lists = this.querySelectorAll('[data-search-suggestions]');

    if (!lists.length) {
      return;
    }

    lists.forEach((list) => {
      list.addEventListener('click', (event) => {
        const suggestionItem = event.target.closest('[data-suggestion]');

        if (!suggestionItem) {
          return;
        }

        const suggestionText = suggestionItem.textContent.trim();

        this.populateSearchInput(suggestionText);
        this.hide();
      });
    });
  }

  hide() {
    this.ariaHidden = true;
  }

  show() {
    this.ariaHidden = false;
  }

  populateSearchInput(text) {
    const searchInput = this.findTargetSearchInput();
    if (!searchInput) {
      return;
    }

    searchInput.value = text;
    const inputEvent = new Event('input', { bubbles: true });
    searchInput.dispatchEvent(inputEvent);
    searchInput.focus();
  }

  findTargetSearchInput() {
    return (
      this.findDrawerSearchInput() ||
      this.findSearchInputById() ||
      this.findActiveSearchInput() ||
      document.querySelector('search-input input[type="search"]')
    );
  }

  findDrawerSearchInput() {
    return this.closest('drawer-element')?.querySelector('search-input input[type="search"]');
  }

  findSearchInputById() {
    const searchId = this.dataset.searchId;
    if (!searchId) {
      return null;
    }

    const escapedId = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(searchId) : searchId;
    const scopedInputs = document.querySelectorAll(
      `search-input#${escapedId} input[type="search"]`
    );
    if (scopedInputs.length) {
      return Array.from(scopedInputs).find(Boolean);
    }

    const fallbackInput = document.getElementById(searchId);
    return fallbackInput?.matches('input[type="search"]') ? fallbackInput : null;
  }

  findActiveSearchInput() {
    return document.activeElement?.matches('input[type="search"]') ? document.activeElement : null;
  }
}

customElements.define('predictive-search-suggestions', PredictiveSearchSuggestions);
